<ng-template #areaModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{ editingArea ? 'Edit' : 'Add' }} Sales Area</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body text-dark">
		<form [formGroup]="areaForm" class="sat-modal-form">
			<mat-form-field appearance="outline" class="sat-code">
				<mat-label>Area Code</mat-label>
				<input type="text" maxlength="3" class="text-uppercase" matInput formControlName="areacode" />
				<mat-hint>Max 3 characters. Cannot change once created.</mat-hint>
			</mat-form-field>
			<mat-form-field appearance="outline" class="sat-desc">
				<mat-label>Description</mat-label>
				<input type="text" maxlength="25" matInput formControlName="areadescription" />
			</mat-form-field>
		</form>
	</div>
	<div class="modal-footer">
		<button class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
		<button class="btn btn-primary" [disabled]="areaForm.invalid" (click)="saveArea()">
			<i class="material-icons">save</i> Save
		</button>
	</div>
</ng-template>

<ng-template #territoryModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{ territoryForm.value.territory_id ? 'Edit' : 'Add' }} Territory</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body text-dark">
		<form [formGroup]="territoryForm" class="sat-modal-form">
			<mat-form-field appearance="outline" class="sat-desc">
				<mat-label>Territory Name</mat-label>
				<input type="text" maxlength="64" matInput formControlName="territory_name" />
			</mat-form-field>
		</form>
	</div>
	<div class="modal-footer">
		<button class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
		<button class="btn btn-primary" [disabled]="territoryForm.invalid" (click)="saveTerritory()">
			<i class="material-icons">save</i> Save
		</button>
	</div>
</ng-template>

<div class="main-content">
	<div class="container-fluid">
		<div class="card sales-areas">
			<div class="card-header card-header-{{color}}-1">
				<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Sales Areas &amp; Territories</h4>
			</div>
			<div class="card-body">
				<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>

				<mat-tab-group mat-align-tabs="start" color="accent">

					<!-- ============ SALES AREAS ============ -->
					<mat-tab label="Sales Areas">
						<div class="sat-toolbar">
							<mat-form-field appearance="outline" class="f-search">
								<mat-label>Search areas</mat-label>
								<input matInput [formControl]="areaSearch" placeholder="code or description">
								<i class="material-icons" matSuffix>search</i>
							</mat-form-field>
							<span class="results">{{ filteredAreas.length }} area{{ filteredAreas.length === 1 ? '' : 's' }}</span>
							<span class="spacer"></span>
							<button class="btn btn-primary sat-add" (click)="addArea()">
								<i class="material-icons">add</i> Add Area
							</button>
						</div>

						<div class="sat-table-wrap">
							<table class="sat-table">
								<thead>
									<tr>
										<th class="sorted-col" [class.sorted]="areaSortField==='areacode'" (click)="setAreaSort('areacode')">
											Code <span class="sort-ind">{{ areaSortField==='areacode' ? (areaSortAsc ? '▲':'▼') : '' }}</span>
										</th>
										<th class="sorted-col" [class.sorted]="areaSortField==='areadescription'" (click)="setAreaSort('areadescription')">
											Description <span class="sort-ind">{{ areaSortField==='areadescription' ? (areaSortAsc ? '▲':'▼') : '' }}</span>
										</th>
										<th class="center sorted-col" [class.sorted]="areaSortField==='usage_count'" (click)="setAreaSort('usage_count')">
											In Use <span class="sort-ind">{{ areaSortField==='usage_count' ? (areaSortAsc ? '▲':'▼') : '' }}</span>
										</th>
										<th class="right">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let area of filteredAreas">
										<td class="mono">{{ area.areacode }}</td>
										<td>{{ area.areadescription }}</td>
										<td class="center">
											<span class="pill" [ngClass]="(area.usage_count > 0) ? 'pill--used' : 'pill--free'">{{ area.usage_count || 0 }}</span>
										</td>
										<td class="right actions">
											<button class="icon-btn edit" title="Edit" (click)="editArea(area)"><i class="material-icons">edit</i></button>
											<button class="icon-btn del" title="{{ area.usage_count > 0 ? 'In use — cannot delete' : 'Delete' }}"
												[disabled]="area.usage_count > 0" (click)="removeArea(area)"><i class="material-icons">delete</i></button>
										</td>
									</tr>
									<tr *ngIf="!isLoading && !filteredAreas.length" class="empty-row">
										<td colspan="4">No sales areas found.</td>
									</tr>
								</tbody>
							</table>
						</div>
					</mat-tab>

					<!-- ============ TERRITORIES ============ -->
					<mat-tab label="Sales Territories">
						<div class="sat-toolbar">
							<mat-form-field appearance="outline" class="f-search">
								<mat-label>Search territories</mat-label>
								<input matInput [formControl]="territorySearch" placeholder="name">
								<i class="material-icons" matSuffix>search</i>
							</mat-form-field>
							<span class="results">{{ filteredTerritories.length }} territor{{ filteredTerritories.length === 1 ? 'y' : 'ies' }}</span>
							<span class="spacer"></span>
							<button class="btn btn-primary sat-add" (click)="addTerritory()">
								<i class="material-icons">add</i> Add Territory
							</button>
						</div>

						<div class="sat-table-wrap">
							<table class="sat-table">
								<thead>
									<tr>
										<th class="sorted-col" [class.sorted]="terrSortField==='territory_id'" (click)="setTerrSort('territory_id')">
											ID <span class="sort-ind">{{ terrSortField==='territory_id' ? (terrSortAsc ? '▲':'▼') : '' }}</span>
										</th>
										<th class="sorted-col" [class.sorted]="terrSortField==='territory_name'" (click)="setTerrSort('territory_name')">
											Name <span class="sort-ind">{{ terrSortField==='territory_name' ? (terrSortAsc ? '▲':'▼') : '' }}</span>
										</th>
										<th class="center sorted-col" [class.sorted]="terrSortField==='usage_count'" (click)="setTerrSort('usage_count')">
											In Use <span class="sort-ind">{{ terrSortField==='usage_count' ? (terrSortAsc ? '▲':'▼') : '' }}</span>
										</th>
										<th class="right">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let t of filteredTerritories">
										<td class="mono">{{ t.territory_id }}</td>
										<td>{{ t.territory_name }}</td>
										<td class="center">
											<span class="pill" [ngClass]="(t.usage_count > 0) ? 'pill--used' : 'pill--free'">{{ t.usage_count || 0 }}</span>
										</td>
										<td class="right actions">
											<button class="icon-btn edit" title="Edit" (click)="editTerritory(t)"><i class="material-icons">edit</i></button>
											<button class="icon-btn del" title="{{ t.usage_count > 0 ? 'In use — cannot delete' : 'Delete' }}"
												[disabled]="t.usage_count > 0" (click)="removeTerritory(t)"><i class="material-icons">delete</i></button>
										</td>
									</tr>
									<tr *ngIf="!isLoading && !filteredTerritories.length" class="empty-row">
										<td colspan="4">No territories found.</td>
									</tr>
								</tbody>
							</table>
						</div>
					</mat-tab>

				</mat-tab-group>
			</div>
		</div>
	</div>
</div>
